import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function InnerContainerRender({ node, isLiveMode, children }) {
  const content = node.content || {};
  
  // Flex/Grid Logik
  const display = content.display || 'flex';
  const flexDirection = content.flexDirection || 'column';
  const flexWrap = content.flexWrap || 'nowrap';
  const justifyContent = content.justifyContent || 'flex-start';
  const alignItems = content.alignItems || 'stretch';
  const gap = content.gap || '0px';

  // Grid Specific Logic
  const gridTemplateColumns = content.gridTemplateColumns || '1fr';
  const gridTemplateRows = content.gridTemplateRows || 'auto';

  // Position Logic
  const position = content.position || 'relative';
  const zIndex = content.zIndex || 'auto';
  
  // Im Live-Mode (Frontend) ist es klickbar, wenn Links gesetzt sind. 
  // Im Editor blockieren wir Events nicht auf dem Container selbst, 
  // da man BaseWidget-Logik braucht, ABER wir setzen minHeight
  const minHeight = isLiveMode ? 'auto' : '50px';

  return (
    <div 
      className="tef-inner-container"
      style={{ 
        display,
        flexDirection: display === 'flex' ? flexDirection : undefined,
        flexWrap: display === 'flex' ? flexWrap : undefined,
        justifyContent: display === 'flex' ? justifyContent : undefined,
        alignItems: display === 'flex' ? alignItems : undefined,
        gridTemplateColumns: display === 'grid' ? gridTemplateColumns : undefined,
        gridTemplateRows: display === 'grid' ? gridTemplateRows : undefined,
        gap,
        position,
        zIndex,
        minHeight,
        width: '100%',
        transition: 'all 0.3s ease'
      }}
    >
      {children}
    </div>
  );
}

registry.register('InnerContainer', {
  label: 'Inner Container',
  icon: '🔲', 
  category: 'layout',
  component: InnerContainerRender,
  
  defaultProps: {
    children: [], // WICHTIG: Erlaubt das Hineinziehen anderer Widgets!
    content: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      gap: '20px',
      position: 'relative',
      zIndex: 'auto'
    },
    style: {
      desktop: {
        padding: '20px',
        backgroundColor: 'rgba(255,255,255,0.02)',
        borderRadius: '8px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Layout Modell',
          fields: [
            { name: 'content.display', label: 'Display-Modus', type: 'select', options: ['flex', 'grid', 'block'] },
            { name: 'content.gap', label: 'Abstand/Gap (z.B. 20px)', type: 'text' }
          ]
        },
        {
          title: 'Flexbox Steuerung',
          fields: [
            { name: 'content.flexDirection', label: 'Richtung', type: 'select', options: ['row', 'column', 'row-reverse', 'column-reverse'] },
            { name: 'content.justifyContent', label: 'Ausrichtung (Horizontal)', type: 'select', options: ['flex-start', 'center', 'flex-end', 'space-between', 'space-around'] },
            { name: 'content.alignItems', label: 'Ausrichtung (Vertikal)', type: 'select', options: ['stretch', 'flex-start', 'center', 'flex-end'] },
            { name: 'content.flexWrap', label: 'Umbruch (Wrap)', type: 'select', options: ['nowrap', 'wrap', 'wrap-reverse'] }
          ]
        },
        {
          title: 'Grid Steuerung (Nur bei Display: Grid)',
          fields: [
            { name: 'content.gridTemplateColumns', label: 'Spalten (z.B. 1fr 1fr)', type: 'text' },
            { name: 'content.gridTemplateRows', label: 'Zeilen (z.B. auto)', type: 'text' }
          ]
        },
        {
          title: 'Position & Z-Index',
          fields: [
            { name: 'content.position', label: 'Positionierung', type: 'select', options: ['static', 'relative', 'absolute', 'fixed', 'sticky'] },
            { name: 'content.zIndex', label: 'Z-Index (z.B. 10)', type: 'text' }
          ]
        }
      ]
    }
  ]
});
